/**
 * Classe d'erreur par défaut Rolling Start.
 * Base commune pour toutes les erreurs applicatives normalisées (ex: RSCartError, RSSetupError…),
 * utilisée à la fois pour le tracking DataDog RUM (via AppModel.error()) et les callbacks UI
 * (ex: paiement, cf. anciennement RollingStartError).
 */
export enum RSErrorCode {
  DEFAULT_ERROR = 0,
  PAYMENT_ERROR = 1,
}

export interface RSErrorOptions {
  code?: RSErrorCode;
  /**
   * Message destiné à être affiché au client dans le navigateur (ex: modale d'erreur paiement).
   * Distinct du `message` technique (hérité de `Error`, utilisé pour le debug/tracking DataDog) :
   * un message technique n'est jamais destiné à être montré tel quel à un client.
   */
  displayedMessage?: string;
}

export class RSError<C = Record<string, unknown>> extends Error {
  context?: C;
  code: RSErrorCode;
  displayedMessage?: string;

  constructor(message: string, context?: C, options?: RSErrorOptions) {
    super(message);
    this.name = "RSError";
    this.context = context;
    this.code = options?.code ?? RSErrorCode.DEFAULT_ERROR;
    this.displayedMessage = options?.displayedMessage;
    Object.setPrototypeOf(this, RSError.prototype);
  }
}
